import {
  ADD_LAYOUT,
  ADD_TEXTURE,
  TOGGLE_IS_ACTIVE_LAYOUT,
  LOAD_LAYOUTS_BY_BOOK_ID,
  REMOVE_DEFAULT_LAYOUT,
} from '../../action-types/entities/layouts';

/**
 * layout model
 * {
 *    placeholders: [id],
 * }
 */

export const addLayout = (layout, placeholders = []) => ({
  type: ADD_LAYOUT,
  layout,
  placeholders,
});

export const loadLayouts = layouts => (dispatch, getState) => {
  const isAutofill = getState().bookProperties.autofill;

  // isAutofillDefault
  layouts.forEach((layout) => {
    if (layout.id === undefined && layout.placeholders.length > 0) {
      if ((isAutofill && 'isAutofillDefault' in layout) || (isAutofill && layout.isCover)) {
        dispatch(addLayout(layout));
      }

      if (!isAutofill) {
        dispatch(addLayout(layout));
      }
    }
  });
};

export const addPlaceholders = (layoutId, placeholders) => ({
  type: ADD_TEXTURE,
  layoutId,
  placeholders,
});


export const setIsActiveLayout = layoutId => ({
  type: TOGGLE_IS_ACTIVE_LAYOUT,
  layoutId,
});

export const loadLayoutsByBookId = bookState => ({
  type: LOAD_LAYOUTS_BY_BOOK_ID,
  bookState,
});

export const removeDefaultLayout = layoutId => ({
  type: REMOVE_DEFAULT_LAYOUT,
  layoutId,
});




// WEBPACK FOOTER //
// ./src/redux/actions/entities/layouts.js